type IconProps = {
  size: number
}

export const CreditCard = ({ size }: IconProps) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 40 40"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11365_325406)">
        <rect
          fill="black"
          height="19.7143"
          rx="3.28571"
          width="28.75"
          x="10"
          y="19"
        />
        <rect
          height="18.8929"
          rx="2.875"
          stroke="white"
          strokeOpacity="0.08"
          strokeWidth="0.821429"
          width="27.9286"
          x="10.4107"
          y="19.4107"
        />
        <path
          clipRule="evenodd"
          d="M24.5786 33.0958C23.5999 33.9402 22.3303 34.45 20.9431 34.45C17.8474 34.45 15.3379 31.9113 15.3379 28.7797C15.3379 25.6481 17.8474 23.1094 20.9431 23.1094C22.3303 23.1094 23.5999 23.6191 24.5786 24.4636C25.5573 23.6191 26.8268 23.1094 28.2141 23.1094C31.3097 23.1094 33.8193 25.6481 33.8193 28.7797C33.8193 31.9113 31.3097 34.45 28.2141 34.45C26.8268 34.45 25.5573 33.9402 24.5786 33.0958Z"
          fill="#ED0006"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M24.5801 33.0958C25.7855 32.0557 26.5499 30.508 26.5499 28.7797C26.5499 27.0514 25.7855 25.5037 24.5801 24.4636C25.5588 23.6191 26.8283 23.1094 28.2155 23.1094C31.3112 23.1094 33.8208 25.6481 33.8208 28.7797C33.8208 31.9113 31.3112 34.45 28.2155 34.45C26.8283 34.45 25.5588 33.9402 24.5801 33.0958Z"
          fill="#F9A000"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M24.5792 33.0931C25.7846 32.053 26.5489 30.5053 26.5489 28.777C26.5489 27.0487 25.7846 25.501 24.5792 24.4609C23.3737 25.501 22.6094 27.0487 22.6094 28.777C22.6094 30.5053 23.3737 32.053 24.5792 33.0931Z"
          fill="#FF5E00"
          fillRule="evenodd"
        />
        <rect height="21.2" rx="4.2" strokeWidth="2" width="30" />
        <rect fill="#172B85" height="19.2" rx="3.2" width="28" x="1" y="1" />
        <rect
          height="18.4"
          rx="2.8"
          stroke="white"
          strokeOpacity="0.08"
          strokeWidth="0.8"
          width="27.2"
          x="1.4"
          y="1.4"
        />
        <path
          clipRule="evenodd"
          d="M9.49982 14.0081H7.80356L6.53157 9.15539C6.4712 8.93217 6.34301 8.73482 6.15444 8.64181C5.68386 8.40807 5.1653 8.22205 4.59961 8.12824V7.94141H7.33215C7.70928 7.94141 7.99212 8.22205 8.03926 8.54799L8.69924 12.0484L10.3947 7.94141H12.0438L9.49982 14.0081ZM12.986 14.0081H11.384L12.7031 7.94141H14.3051L12.986 14.0081ZM16.3785 9.62135C16.4256 9.2946 16.7084 9.10777 17.0384 9.10777C17.557 9.06087 18.1219 9.15468 18.5933 9.38761L18.8761 8.08143C18.4047 7.8946 17.8861 7.80078 17.4156 7.80078C15.8607 7.80078 14.7293 8.64111 14.7293 9.80737C14.7293 10.6946 15.5307 11.1605 16.0964 11.4411C16.7084 11.721 16.9441 11.9078 16.897 12.1876C16.897 12.6074 16.4256 12.7942 15.955 12.7942C15.3893 12.7942 14.8236 12.6543 14.3059 12.4206L14.023 13.7275C14.5887 13.9605 15.2008 14.0543 15.7664 14.0543C17.5098 14.1004 18.5933 13.2609 18.5933 12.0008C18.5933 10.414 16.3785 10.3209 16.3785 9.62135ZM24.2001 14.0081L22.9281 7.94141H21.5619C21.279 7.94141 20.9962 8.12824 20.9019 8.40807L18.5465 14.0081H20.1956L20.5248 13.1217H22.551L22.7396 14.0081H24.2001ZM21.7966 9.57578L22.2672 11.8622H20.948L21.7966 9.57578Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_11365_325406">
          <rect fill="white" height="40" width="40" />
        </clipPath>
      </defs>
    </svg>
  )
}
